import { platformRead } from './http'
export const queryDeviceLocations = (data, options = {}) => platformRead({
  method: 'post', url: '/jetlinks/visualization/device-locations/_query', data
}, options)
